/** Email signature helpers. The block is marked so a template or Claude draft can replace the body and keep it. */
export function signatureBlock(sig: string | null | undefined): string {
  if (!sig || !sig.replace(/<[^>]+>/g, "").trim()) return "";
  return `<div><br></div><div><br></div><div data-signature="1">${sig}</div>`;
}
/** Body for a fresh editor: an empty line to type on, then the signature. */
export function startWithSignature(sig: string | null | undefined): string {
  const b = signatureBlock(sig);
  return b ? `<div><br></div>${b}` : "";
}
/** Put new content above the signature (templates, Claude drafts). */
export function withSignature(body: string, sig: string | null | undefined): string {
  return body + signatureBlock(sig);
}
